const debug = {
    dev: false,
    head: "CompanySettingsPermissions"
}

// views not available to different type of users by default
const defaultDisabledViews = {
    manager : [],
    user    : [],
    guest   : [2,3,4,5,10,21,23],
    client  : [], //[2,3,4,5,10,21,23],
}

const defaultDisabledComponents = {
    manager : [],
    user    : [],
    guest   : [],
    client  : ["home", /*"projects",*/ "tools", /*"chat",*/ "quick-add", "search", "users", "settings", "help"],
}

export default class CompanySettingsPermissions {

    public disabledComponents       : any
    public disabledCustomViews       : any

    constructor(data:any) {

        debug.dev && console.log(debug.head,'.constructor', data);

        this._init(data);

        debug.dev && console.log(debug.head,'.constructor - done', this);
    }

    _init(data:any) {

        debug.dev && console.log(debug.head,'.init', data);

        // disabled components i.e. chats, tools, specific home screens etc
        this.disabledComponents = {
            manager : new Set(_.get(data,'disabledComponents.manager', defaultDisabledComponents.manager)),
            user    : new Set(_.get(data,'disabledComponents.user', defaultDisabledComponents.user)),
            guest   : new Set(_.get(data,'disabledComponents.guest', defaultDisabledComponents.guest)),
            client  : new Set(defaultDisabledComponents.client), //new Set(_.get(data,'disabledComponents.client', defaultDisabledComponents.client))
        }

        this.disabledCustomViews = {
            manager : new Set(_.get(data,'disabledCustomViews.manager', defaultDisabledViews.manager)),
            user    : new Set(_.get(data,'disabledCustomViews.user', defaultDisabledViews.user)),
            guest   : new Set(_.get(data,'disabledCustomViews.guest', defaultDisabledViews.guest)),
            client  : new Set(defaultDisabledViews.client), //new Set(_.get(data,'disabledCustomViews.client', defaultDisabledViews.client))
        }

        debug.dev && console.log(debug.head, this.disabledComponents);
        debug.dev && console.log(debug.head, this.disabledCustomViews);
    }

    toJSON() {

        const disabledCustomViews = {
            manager : [...this.disabledCustomViews.manager],
            user    : [...this.disabledCustomViews.user],
            guest   : [...this.disabledCustomViews.guest],
            client  : [...this.disabledCustomViews.client],
        }

        // set -> array
        const disabledComponents = {
            manager : [...this.disabledComponents.manager],
            user    : [...this.disabledComponents.user],
            guest   : [...this.disabledComponents.guest],
            client  : [...this.disabledComponents.client],
        };

        return {
            disabledComponents  : (disabledComponents!==defaultDisabledComponents)?disabledComponents:null,
            disabledCustomViews :  (disabledCustomViews!==defaultDisabledViews)?disabledCustomViews:null
        }
    }
}